var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrailerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "28px",
    viewBox: "0 0 50 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons8-fuel-tank-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-fuel-tank-filled",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,3.45126646e-31 C0.449219,3.45126646e-31 0,0.445313 0,1 C3.87238173e-16,8.72805887 3.87238173e-16,14.3831878 0,17.9653868 C0,18.553039 0.200689168,19 1,19 L3.4664143,19 C2.6773523,19.953125 2.2007893,21.171875 2.2007893,22.5 C2.2007893,25.527344 4.6734453,28 7.7007893,28 C10.2125083,28 12.3414143,26.289063 12.9937583,23.980469 C13.0601643,23.984375 13.1304773,24 13.2007893,24 L31.214844,24 C31.871094,26.300781 33.996094,28 36.5,28 C39.003906,28 41.128906,26.300781 41.785156,24 L49,24 C49.550781,24 49.4175445,17.550781 49.4175445,17 L49.1533387,17 L47.1533387,17 L47.1533387,2 C47.1533387,0.898438 46.2549017,-4.14151975e-30 45.1533387,0 L1,3.45126646e-31 Z M23.5,6 C23.5,6 26,9.117188 26,10.5 C26,11.882813 24.882813,13 23.5,13 C22.117188,13 21,11.882813 21,10.5 C21,9.117188 23.5,6 23.5,6 Z M7.5,19 C9.445313,19 11,20.554688 11,22.5 C11,24.445313 9.445313,26 7.5,26 C5.554688,26 4,24.445313 4,22.5 C4,20.554688 5.554688,19 7.5,19 Z M11.734375,19 L32.265625,19 C31.1392223,19.832031 30.4032201,20.867188 30.2368205,22 L13.7631795,22 C13.5967799,20.867188 12.8607777,19.832031 11.734375,19 Z M36.5,19 C38.445313,19 40,20.554688 40,22.5 C40,24.445313 38.445313,26 36.5,26 C34.554688,26 33,24.445313 33,22.5 C33,20.554688 34.554688,19 36.5,19 Z M40.734375,19 L48,19 L48,22 L41.972656,22 C41.871094,20.867188 41.421875,19.832031 40.734375,19 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerIcon);
export default __webpack_public_path__ + "static/media/trailerIcon.cd883b314accd8f61477b87d69ec22ad.svg";
export { ForwardRef as ReactComponent };